import Service from 'common/types/Service';
import {createFetchListActions} from 'common/actions/utils';
import OndemandApi from 'common/api/OndemandApi';


export const {
  fetchServices,
  fetchServicesIfNeeded,
} = createFetchListActions({
  name: 'service',
  DataType: Service,
  keys: ['agencyId'],
  api: new OndemandApi(),
  idProp: 'service_id',
});



// WEBPACK FOOTER //
// ./src/ondemand/actions/service.js